import { ReactNode } from "react";
import "./Rotator.scss";

interface Props {
  msPerRotation?: string;
  size: "24px";
  children: ReactNode;
}

const Rotator = ({ msPerRotation, children, size }: Props) => (
  <div
    className="rotator-norad"
    style={{
      width: size,
      height: size,
    }}
  >
    <div
      className="rotator-norad__inner"
      style={{
        animationDuration: msPerRotation ? msPerRotation + "ms" : undefined,
        width: size,
        height: size,
      }}
    >
      {children}
    </div>
  </div>
);
export default Rotator;
